export const tickerItems = [
  "本轮线报已更新 37 条 · 其中独家来源 12 条",
  "话题「幕后剧组风波」讨论量 3 小时内上涨 214%",
  "匿名投稿通道今日收到 486 份，已过初筛 96 份",
  "新上线「信源标注」规则：每条线报均标注来源等级",
  "热评榜刷新：置顶话题评论数突破 1.2 万",
  "本页为演示站点，所示内容均为虚构示例，不对应任何真实人物或事件",
];

export const heroStats = [
  { value: "18,642", label: "累计线报条目", icon: "ri-file-list-3-line" },
  { value: "1,204", label: "今日匿名投稿", icon: "ri-send-plane-line" },
  { value: "527", label: "在线围观人数", icon: "ri-user-voice-line" },
  { value: "3,918", label: "已标注信源", icon: "ri-shield-check-line" },
];

export const heroImages = {
  main: "https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20representing%20anonymous%20insider%20leaks%2C%20layered%20sealed%20confidential%20documents%20and%20torn%20paper%20textures%20in%20warm%20cream%20and%20deep%20vermilion%20tones%2C%20dramatic%20side%20lighting%2C%20grainy%20film%20aesthetic%2C%20no%20people%2C%20no%20readable%20text%2C%20moody%20atmospheric%20stylized%20wide%20composition%2C%20high%20detail&width=1200&height=640&seq=hl15-hero-main&orientation=landscape&nocache=true",
  side: "https://readdy.ai/api/search-image?query=Stylized%20dark%20archive%20room%20filled%20with%20sealed%20evidence%20cabinets%20and%20glowing%20folder%20edges%2C%20warm%20amber%20light%20beams%20cutting%20through%20haze%2C%20abstract%20confidential%20investigative%20atmosphere%2C%20cinematic%20editorial%20wide%20illustration%2C%20no%20people%2C%20no%20text%2C%20rich%20contrast%2C%20artistic%20film%20grain&width=1200&height=520&seq=hl15-hero-side&orientation=landscape&nocache=true",
};

export type Topic = {
  id: string;
  label: string;
  count: number;
  hot: boolean;
  span: string;
  tone: "primary" | "accent" | "secondary";
};

export const topics: Topic[] = [
  { id: "ent", label: "幕后剧组风波", count: 2841, hot: true, span: "lg:col-span-2 lg:row-span-2", tone: "primary" },
  { id: "tech", label: "产品未公开内测", count: 1936, hot: true, span: "lg:col-span-2", tone: "accent" },
  { id: "finance", label: "资金流向疑点", count: 1502, hot: false, span: "lg:col-span-2", tone: "secondary" },
  { id: "consumer", label: "消费维权线报", count: 1188, hot: true, span: "lg:col-span-2", tone: "accent" },
  { id: "campus", label: "校园匿名投稿", count: 974, hot: false, span: "lg:col-span-2", tone: "secondary" },
  { id: "workplace", label: "职场内部消息", count: 861, hot: false, span: "lg:col-span-2", tone: "primary" },
  { id: "supply", label: "供应链内情", count: 642, hot: false, span: "lg:col-span-2", tone: "secondary" },
  { id: "live", label: "直播现场翻车", count: 588, hot: true, span: "lg:col-span-2", tone: "primary" },
  { id: "contract", label: "合同条款曝光", count: 431, hot: false, span: "lg:col-span-2", tone: "accent" },
];

export type Leak = {
  id: string;
  title: string;
  excerpt: string;
  image: string;
  source: "独家来源" | "线人投稿" | "匿名投稿";
  cat: "最新" | "独家" | "热议";
  tags: string[];
  time: string;
  views: number;
  comments: number;
  author: string;
};

export const leaks: Leak[] = [
  {
    id: "leak-1",
    title: "某剧组换角内情：试镜名单与最终定妆差异流出",
    excerpt: "据多位自称剧组内部的线人描述，定妆环节曾出现两份不同版本名单，其中一份从未对外公开。以下为线报整理与信源等级标注。",
    image: "https://readdy.ai/api/search-image?query=Abstract%20editorial%20image%20about%20entertainment%20industry%20rumors%2C%20backstage%20curtain%20silhouettes%20and%20warm%20stage%20light%20rays%2C%20vermilion%20and%20amber%20tones%2C%20stylized%20cinematic%20illustration%2C%20no%20faces%2C%20no%20text%2C%20grainy%20film%20texture&width=800&height=520&seq=hl15-leak-01&orientation=landscape",
    source: "独家来源",
    cat: "独家",
    tags: ["幕后剧组风波", "现场目击"],
    time: "12 分钟前",
    views: 42310,
    comments: 1284,
    author: "线人编号 A-0731",
  },
  {
    id: "leak-2",
    title: "未发布机型真机图与包装清单，来自供应链内部",
    excerpt: "一份标注日期为本周的物料清单被匿名递交，包含配色与配件信息。本页仅展示投稿人转述内容，真假请自行判断。",
    image: "https://readdy.ai/api/search-image?query=Abstract%20editorial%20image%20of%20digital%20data%20streams%20and%20encrypted%20files%20on%20dark%20screens%2C%20warm%20orange%20glow%2C%20stylized%20technology%20illustration%2C%20no%20readable%20text%2C%20cinematic%20mood%2C%20fine%20grain&width=800&height=520&seq=hl15-leak-02&orientation=landscape",
    source: "线人投稿",
    cat: "最新",
    tags: ["产品未公开内测", "供应链内情"],
    time: "48 分钟前",
    views: 28740,
    comments: 906,
    author: "线人编号 C-1180",
  },
  {
    id: "leak-3",
    title: "项目资金流向清单流出，多笔关联支出被标红",
    excerpt: "投稿人提供的表格截图显示若干笔款项去向模糊，已在信源校验环节标记为待核。相关描述均为投稿人单方陈述。",
    image: "https://readdy.ai/api/search-image?query=Abstract%20editorial%20image%20of%20scattered%20financial%20documents%20and%20wax%20seals%20in%20warm%20sepia%20tones%2C%20vintage%20investigative%20mood%2C%20stylized%20illustration%2C%20no%20readable%20text%2C%20no%20faces%2C%20soft%20film%20grain&width=800&height=520&seq=hl15-leak-03&orientation=landscape",
    source: "匿名投稿",
    cat: "热议",
    tags: ["资金流向疑点", "合同条款曝光"],
    time: "2 小时前",
    views: 51260,
    comments: 2317,
    author: "匿名投稿者",
  },
  {
    id: "leak-4",
    title: "深夜路边目击记录：现场照片与时间线整理",
    excerpt: "多位围观者提交了同一时段的路口照片与定位时间。信源被标注为「多源交叉」，但画面清晰度有限。",
    image: "https://readdy.ai/api/search-image?query=Abstract%20editorial%20image%20of%20a%20rainy%20city%20street%20at%20night%20reflected%20in%20shop%20windows%2C%20warm%20amber%20street%20lights%2C%20moody%20stylized%20illustration%2C%20no%20people%2C%20no%20text%2C%20atmospheric%20grain&width=800&height=520&seq=hl15-leak-04&orientation=landscape",
    source: "线人投稿",
    cat: "最新",
    tags: ["校园匿名投稿", "现场目击"],
    time: "3 小时前",
    views: 19820,
    comments: 642,
    author: "线人编号 D-2204",
  },
  {
    id: "leak-5",
    title: "售后记录批量曝光：同批次产品问题被集中提及",
    excerpt: "一份据称来自维修网点的记录被递交，重复出现的故障描述被整理成词频图。本页仅作信源展示，不构成任何结论。",
    image: "https://readdy.ai/api/search-image?query=Abstract%20editorial%20still%20life%20of%20a%20cracked%20smartphone%20and%20stacked%20paper%20receipts%20on%20a%20warm%20textured%20wood%20surface%2C%20dramatic%20soft%20light%2C%20stylized%20product%20photography%20illustration%2C%20no%20text&width=800&height=520&seq=hl15-leak-05&orientation=landscape",
    source: "独家来源",
    cat: "独家",
    tags: ["消费维权线报", "供应链内情"],
    time: "5 小时前",
    views: 33170,
    comments: 1503,
    author: "线人编号 B-0912",
  },
  {
    id: "leak-6",
    title: "内部邮件截图：会议安排与人事变动的时间差",
    excerpt: "投稿人称邮件来源为离职员工信箱。信源等级标注为「单一来源 · 待交叉验证」，请谨慎转发。",
    image: "https://readdy.ai/api/search-image?query=Abstract%20editorial%20image%20of%20an%20empty%20office%20corridor%20with%20warm%20afternoon%20light%20and%20closed%20doors%2C%20investigative%20mood%2C%20stylized%20cinematic%20illustration%2C%20no%20people%2C%20no%20text%2C%20gentle%20grain&width=800&height=520&seq=hl15-leak-06&orientation=landscape",
    source: "匿名投稿",
    cat: "热议",
    tags: ["职场内部消息", "合同条款曝光"],
    time: "6 小时前",
    views: 24960,
    comments: 811,
    author: "匿名投稿者",
  },
];

export const feedTabs = ["全部", "独家", "热议"] as const;

export type HotItem = {
  rank: number;
  title: string;
  tag: string;
  comments: number;
  participants: number;
  snippet: string;
};

export const hotDiscussions: HotItem[] = [
  {
    rank: 1,
    title: "那条被撤下的通告，到底改了几个字？",
    tag: "幕后剧组风波",
    comments: 12840,
    participants: 3120,
    snippet: "「我把两个版本截图叠在一起对比，第三行确实不一样。」",
  },
  {
    rank: 2,
    title: "供应链清单里的两个日期对不上，有人解释下吗",
    tag: "供应链内情",
    comments: 9326,
    participants: 2480,
    snippet: "「同一个物料编码出现了两次，间隔刚好三天。」",
  },
  {
    rank: 3,
    title: "资金表里那几笔标红，标红规则是谁定的？",
    tag: "资金流向疑点",
    comments: 7715,
    participants: 1904,
    snippet: "「红笔不是原作者画的，是后来拍照的人圈的。」",
  },
  {
    rank: 4,
    title: "同批次售后集中出现，官方口径什么时候更新",
    tag: "消费维权线报",
    comments: 5402,
    participants: 1338,
    snippet: "「我这边网点说配件要等两周，跟帖里有人说三天到货。」",
  },
  {
    rank: 5,
    title: "深夜目击照片的时间戳，有人做过比对了吗",
    tag: "现场目击",
    comments: 4118,
    participants: 962,
    snippet: "「定位和照片里的路灯位置差了一个路口。」",
  },
];

export type CommentItem = {
  id: string;
  name: string;
  badge: string;
  text: string;
  time: string;
  likes: number;
  replies: number;
  hot: boolean;
};

export const comments: CommentItem[] = [
  { id: "c1", name: "夜航船", badge: "常驻线人", text: "这份名单和我上个月在小群里看到的一版对得上，先蹲后续交叉验证。", time: "刚刚", likes: 1284, replies: 96, hot: true },
  { id: "c2", name: "匿名围观者", badge: "匿名", text: "求问信源等级怎么分的？标注里「待核」是不是等于不确定？", time: "2 分钟前", likes: 842, replies: 61, hot: true },
  { id: "c3", name: "南墙不改", badge: "资深爆料人", text: "照片的阴影方向和时间戳能对上，但路灯编号要放大才看得清，别急着下结论。", time: "9 分钟前", likes: 670, replies: 44, hot: false },
  { id: "c4", name: "半盏茶", badge: "匿名", text: "评论区比正文还精彩，蹲一个把两个版本叠图的楼主。", time: "14 分钟前", likes: 553, replies: 27, hot: false },
  { id: "c5", name: "拆解机", badge: "技术组", text: "清单里的物料编码规则我拆过了，第三个字段确实是批次号，对得上日期。", time: "21 分钟前", likes: 498, replies: 39, hot: true },
  { id: "c6", name: "路口的风", badge: "常驻线人", text: "建议把多源交叉的都单开一个话题墙，查起来方便很多。", time: "35 分钟前", likes: 421, replies: 18, hot: false },
];

export type SectionItem = {
  id: string;
  name: string;
  desc: string;
  count: string;
  icon: string;
  tone: "primary" | "accent" | "secondary";
};

export const sections: SectionItem[] = [
  { id: "s-ent", name: "娱乐圈线报区", desc: "剧组、通告、现场的目击整理", count: "2,841 条", icon: "ri-movie-2-line", tone: "primary" },
  { id: "s-tech", name: "科技内测区", desc: "产品、内测、物料与爆料对照", count: "1,936 条", icon: "ri-cpu-line", tone: "accent" },
  { id: "s-money", name: "资金疑点区", desc: "表格、流水与条款的线索讨论", count: "1,502 条", icon: "ri-line-chart-line", tone: "secondary" },
  { id: "s-rights", name: "消费维权区", desc: "售后、批次与集中问题记录", count: "1,188 条", icon: "ri-shield-star-line", tone: "accent" },
  { id: "s-campus", name: "校园投稿区", desc: "校园周边匿名来信与目击", count: "974 条", icon: "ri-school-line", tone: "secondary" },
  { id: "s-work", name: "职场内情区", desc: "邮件、会议与人事时间差", count: "861 条", icon: "ri-briefcase-4-line", tone: "primary" },
];

export type StepItem = {
  step: string;
  title: string;
  desc: string;
  icon: string;
};

export const submitSteps: StepItem[] = [
  { step: "01", title: "填写线报", desc: "描述事件、时间与地点，可附图片或链接，全程无需注册。", icon: "ri-edit-2-line" },
  { step: "02", title: "选择信源等级", desc: "标注为独家来源、线人投稿或匿名投稿，方便读者判断可信度。", icon: "ri-price-tag-3-line" },
  { step: "03", title: "初筛与交叉验证", desc: "值班编辑核对时间线，多源一致的线报会加「已交叉」标记。", icon: "ri-shield-check-line" },
  { step: "04", title: "上线话题墙", desc: "通过初筛的线报进入对应话题分区，并开放评论讨论。", icon: "ri-layout-grid-line" },
];

export const sourcePoints = [
  { title: "独家来源", desc: "由本站联络的线人单独提供，尚未在其他渠道出现，附信源编号。", icon: "ri-award-line", tone: "primary" as const },
  { title: "线人投稿", desc: "来自自称知情者的投稿，保留原始表述，不做事实性背书。", icon: "ri-send-plane-line", tone: "accent" as const },
  { title: "匿名投稿", desc: "无法追溯身份的来稿，仅作记录展示，读者需自行判断。", icon: "ri-user-unfollow-line", tone: "secondary" as const },
  { title: "多源交叉", desc: "两条以上独立来源指向同一细节，会额外标注「已交叉」。", icon: "ri-links-line", tone: "accent" as const },
];

export const navLinks = [
  { href: "#topics", label: "话题墙" },
  { href: "#leaks", label: "最新线报" },
  { href: "#discussion", label: "热议榜" },
  { href: "#comments", label: "评论墙" },
  { href: "#sources", label: "信源规则" },
];